// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
/* Breakpoints */
.ant-notification {
  z-index: 20000;
}
.dashboard-module__copyright--eG692 {
  color: #ff0000;
  font-size: 12px;
  text-align: center;
}
.dashboard-module__layoutHeader--h0fZ6 {
  background-color: #005866;
  min-height: 100vh;
}
.dashboard-module__layoutHeader--h0fZ6 .dashboard-module__layoutOutlet--wlXoS {
  padding-top: 60px;
}
@media only screen and (max-width: 600px) {
  .dashboard-module__layoutHeader--h0fZ6 .dashboard-module__layoutOutlet--wlXoS {
    padding-top: 0;
  }
}
.dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i {
  background-color: #005866;
  padding: 0;
  display: grid;
  grid-template-columns: 280px 1fr min-content;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9999;
}
@media only screen and (max-width: 600px) {
  .dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i {
    top: initial;
    bottom: 0;
    display: flex;
    justify-content: space-between;
  }
  .dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__mobileMenu--kCdBa {
    position: fixed;
    left: 0;
    right: 0;
    width: 100%;
    bottom: 60px;
    pointer-events: none;
  }
  .dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__mobileMenu--kCdBa.dashboard-module__opened--o2dlS {
    pointer-events: all;
  }
  .dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__mobileMenu--kCdBa.dashboard-module__opened--o2dlS .dashboard-module__headerMenu--nN4l8 {
    transform: translateX(0);
  }
  .dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__mobileMenu--kCdBa .dashboard-module__headerMenu--nN4l8 {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    overflow: hidden;
    transform: translateX(100%);
    flex-direction: column;
    padding-left: 0;
    transition: 350ms ease-in-out;
    transition-property: all;
  }
}
@media only screen and (max-width: 991px) {
  .dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i {
    grid-template-columns: min-content 1fr auto;
  }
}
.dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__mainMenuButton--Of9IF {
  display: flex;
  align-items: center;
  padding-right: 16px;
  visibility: hidden;
}
@media only screen and (max-width: 1200px) {
  .dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__mainMenuButton--Of9IF {
    visibility: visible;
  }
}
.dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__leftActions--nVFj7 {
  display: flex;
  align-items: center;
  gap: 8px;
}
.dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__rightActions--bFFXz {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-right: 8px;
  justify-content: flex-end;
}
.dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__menuButton--UdHib {
  display: none;
  align-items: center;
  padding-left: 16px;
}
@media only screen and (max-width: 1200px) {
  .dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__menuButton--UdHib {
    display: flex;
  }
}
.dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__exportsButton--flROV {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.3s;
}
.dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__exportsButton--flROV:hover {
  background-color: rgba(61, 197, 86, 0.1);
}
.dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__exportsButton--flROV:active {
  background-color: rgba(61, 197, 86, 0.2);
}
.dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__headerMenu--nN4l8 {
  background-color: #005866;
}
@media only screen and (max-width: 991px) {
  .dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__headerMenu--nN4l8 {
    padding-left: 16px;
  }
}
.dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__headerMenu--nN4l8 .ant-menu-item {
  padding-left: 12px;
  padding-right: 12px;
}
.dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__headerMenu--nN4l8 .ant-menu-item:hover {
  background-color: #004b57;
}
.dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__headerMenu--nN4l8 .ant-menu-item-icon {
  width: 1.2em;
  height: 1.2em;
  color: #3dc556;
  position: relative;
  top: 3px;
}
.dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__headerMenu--nN4l8 .ant-menu-item-icon svg {
  width: 100%;
  height: 100%;
}
.dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__headerMenu--nN4l8 .ant-menu-item-selected {
  background-color: #004b57;
}
.dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__headerMenu--nN4l8 .ant-menu-item-selected::after {
  border-bottom: 3px solid #3dc556;
  margin-left: -16px;
  margin-right: -16px;
}
.dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__headerMenu--nN4l8 .ant-menu-sub {
  background-color: #005866;
}
.dashboard-module__layoutHeader--h0fZ6 .dashboard-module__header--Ju_4i .dashboard-module__headerMenu--nN4l8 .ant-menu-title-content a {
  color: white;
  font-size: 13px;
}
.dashboard-module__layout--exWag {
  background-color: #ffffff;
  min-height: calc(100vh - 60px);
}
.dashboard-module__layout--exWag .dashboard-module__wrapper--UgHhS {
  min-height: calc(100vh - 60px);
}
@media only screen and (max-width: 600px) {
  .dashboard-module__layout--exWag {
    min-height: 100vh;
  }
  .dashboard-module__layout--exWag .dashboard-module__wrapper--UgHhS {
    min-height: 100vh;
  }
}
.dashboard-module__layout--exWag .dashboard-module__contentWrapper--X6J1u {
  min-height: calc(100vh - 125px);
  background-color: #ffffff;
}
.dashboard-module__layout--exWag .dashboard-module__contentWrapper--X6J1u.dashboard-module__isDesktop--I7nzq {
  padding-left: 280px;
}
.dashboard-module__layout--exWag .dashboard-module__contentWrapper--X6J1u .dashboard-module__content--tR01X {
  background-color: #ffffff;
  margin-top: 8px;
  padding: 16px 32px;
  border-radius: 4px;
}
@media only screen and (max-width: 1200px) {
  .dashboard-module__layout--exWag .dashboard-module__contentWrapper--X6J1u .dashboard-module__content--tR01X {
    padding: 16px;
  }
}
.dashboard-module__layout--exWag .dashboard-module__footer--qxK1M {
  background-color: #ffffff;
  height: 60px;
  padding: 0;
  font-size: 12px;
  letter-spacing: 1.2px;
  word-spacing: 2px;
  display: flex;
  align-items: center;
  justify-content: centeR;
}
.dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs {
  min-height: calc(100vh - 65px);
  background-color: #00414b;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
  padding-top: 16px;
  position: fixed;
}
@media only screen and (max-width: 600px) {
  .dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs {
    min-height: 100vh;
  }
}
.dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs.dashboard-module__isMobile--HzwXt {
  z-index: 9998;
  top: 64px;
}
@media only screen and (max-width: 600px) {
  .dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs.dashboard-module__isMobile--HzwXt {
    top: 0;
  }
}
.dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs .dashboard-module__menu--gEt2m {
  background-color: #00414b;
  border-right: initial;
}
.dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs .dashboard-module__menu--gEt2m .ant-menu-item-icon {
  width: 1.5em;
  height: 1.5em;
  color: #1d9333;
  position: relative;
}
.dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs .dashboard-module__menu--gEt2m .ant-menu-item-icon svg {
  width: 100%;
  height: 100%;
}
.dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs .dashboard-module__menu--gEt2m .ant-menu-submenu-title,
.dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs .dashboard-module__menu--gEt2m .ant-menu-item {
  height: initial;
  margin: 0;
  padding: 0 0;
  overflow: initial;
  margin-top: 10px;
}
.dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs .dashboard-module__menu--gEt2m .ant-menu-submenu-title:before,
.dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs .dashboard-module__menu--gEt2m .ant-menu-item:before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 0;
  opacity: 0;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
  background-color: #2d5d67;
  transition: 150ms ease-in-out;
  transition-property: all;
}
.dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs .dashboard-module__menu--gEt2m .ant-menu-submenu-title:hover:before,
.dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs .dashboard-module__menu--gEt2m .ant-menu-item:hover:before {
  opacity: 1;
  width: 102%;
}
.dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs .dashboard-module__menu--gEt2m .ant-menu-item-selected {
  background-color: initial;
}
.dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs .dashboard-module__menu--gEt2m .ant-menu-item-selected:before {
  opacity: 1;
  width: 102%;
}
.dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs .dashboard-module__menu--gEt2m .ant-menu-item-selected:after {
  right: 0.5px;
  display: none;
}
.dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs .dashboard-module__menu--gEt2m .ant-menu-sub {
  background-color: #00414b;
}
.dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs .dashboard-module__menu--gEt2m .ant-menu-title-content {
  color: white;
  position: relative;
  font-size: 16px;
  display: block;
}
.dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs .dashboard-module__menu--gEt2m .ant-menu-title-content a {
  color: white;
  font-size: 16px;
  display: block;
}
.dashboard-module__layout--exWag .dashboard-module__sider--nQ3Gs .dashboard-module__menu--gEt2m .ant-menu-submenu-arrow {
  color: white;
}
.ant-menu-submenu-popup {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./components/templates/dashboard/dashboard.module.less","webpack://./styles/variables.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;AAC7F,gBAAgB;AC0JhB;EACE,cAAA;ADxJF;AALA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AAOF;AAJA;EACE,yBAAA;EACA,iBAAA;AAMF;AARA;EAKI,iBAAA;AAMJ;AAJI;EAAA;IACE,cAAA;EAOJ;AACF;AAhBA;EAaI,yBAAA;EACA,UAAA;EACA,aAAA;EACA,4CAAA;EACA,gDAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;AAMJ;AAJI;EAAA;IACE,YAAA;IACA,SAAA;IACA,aAAA;IACA,8BAAA;EAOJ;EAXE;IAOI,eAAA;IACA,OAAA;IACA,QAAA;IACA,WAAA;IACA,YAAA;IACA,oBAAA;EAON;EALM;IACE,mBAAA;EAOR;EARM;IAII,wBAAA;EAOV;EAzBE;IAuBM,4BAAA;IACA,6BAAA;IACA,gBAAA;IACA,2BAAA;IACA,sBAAA;IACA,eAAA;IACA,6BAAA;IACA,wBAAA;EAKR;AACF;AADI;EAAA;IACE,2CAAA;EAIJ;AACF;AAjEA;EAgEM,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAIN;AAFM;EAAA;IACE,mBAAA;EAKN;AACF;AA5EA;EA2EM,aAAA;EACA,mBAAA;EACA,QAAA;AAIN;AAjFA;EAiFM,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;AAGN;AAxFA;EAyFM,aAAA;EACA,mBAAA;EACA,kBAAA;AAEN;AAAM;EAAA;IACE,aAAA;EAGN;AACF;AAlGA;EAmGM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;AAEN;AAAM;EACE,wCAAA;AAER;AACM;EACE,wCAAA;AACR;AAjHA;EAqHM,yBAAA;AADN;AAGM;EAAA;IACE,kBAAA;EAAN;AACF;AAzHA;EA4HQ,kBAAA;EACA,mBAAA;AAAR;AAEQ;EACE,yBAAA;AAAV;AAhIA;EAqIQ,YAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;AAFR;AAvIA;EA4IU,WAAA;EACA,YAAA;AAFV;AA3IA;EAkJQ,yBAAA;AAJR;AAMQ;EACE,gCAAA;EACA,kBAAA;EACA,mBAAA;AAJV;AAnJA;EA4JQ,yBAAA;AANR;AAtJA;EAiKU,YAAA;EACA,eAAA;AARV;AAeA;EACE,yBAAA;EACA,8BAAA;AAbF;AAWA;EAKI,8BAAA;AAbJ;AAgBE;EAAA;IACE,iBAAA;EAbF;EAYA;IAII,iBAAA;EAbJ;AACF;AAAA;EAiBI,+BAAA;EACA,yBAAA;AAdJ;AAgBI;EACE,mBAAA;AAdN;AAPA;EAyBM,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAfN;AAiBM;EAAA;IACE,aAAA;EAdN;AACF;AAlBA;EAqCI,yBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhBJ;AA7BA;EAiDI,8BAAA;EACA,yBAAA;EACA,gDAAA;EACA,iBAAA;EACA,eAAA;AAjBJ;AAmBI;EAAA;IACE,iBAAA;EAhBJ;AACF;AAkBI;EACE,aAAA;EACA,SAAA;AAhBN;AAkBM;EAAA;IACE,MAAA;EAfN;AACF;AAlDA;EAqEM,yBAAA;EACA,qBAAA;AAhBN;AAtDA;EAyEQ,YAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;AAhBR;AA5DA;EA+EU,WAAA;EACA,YAAA;AAhBV;AAhEA;;EAsFQ,eAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAlBR;AAoBQ;;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,gDAAA;EACA,yBAAA;EACA,6BAAA;EACA,wBAAA;AAjBV;AAqBU;;EACE,UAAA;EACA,WAAA;AAlBZ;AA3FA;EAmHQ,yBAAA;AArBR;AAuBQ;EACE,UAAA;EACA,WAAA;AArBV;AAwBQ;EACE,YAAA;EACA,aAAA;AAtBV;AAtGA;EAiIQ,yBAAA;AAxBR;AAzGA;EAqIQ,YAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAzBR;AA/GA;EA2IU,YAAA;EACA,eAAA;EACA,cAAA;AAzBV;AApHA;EAkJQ,YAAA;AA3BR;AAiCA;EACE,aAAA;AA/BF","sourcesContent":["@import '../../../styles/variables.less';\n\n.copyright {\n  color: #ff0000;\n  font-size: 12px;\n  text-align: center;\n}\n\n.layoutHeader {\n  background-color: @header-color;\n  min-height: 100vh;\n\n  .layoutOutlet {\n    padding-top: 60px;\n\n    @media @mobileXL {\n      padding-top: 0;\n    }\n  }\n\n  .header {\n    background-color: @header-color;\n    padding: 0;\n    display: grid;\n    grid-template-columns: 280px 1fr min-content;\n    box-shadow: @v2-bg-card-shadow;\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    z-index: 9999;\n\n    @media @mobileXL {\n      top: initial;\n      bottom: 0;\n      display: flex;\n      justify-content: space-between;\n\n      .mobileMenu {\n        position: fixed;\n        left: 0;\n        right: 0;\n        width: 100%;\n        bottom: @header-height;\n        pointer-events: none;\n\n        &.opened {\n          pointer-events: all;\n\n          .headerMenu {\n            transform: translateX(0);\n          }\n        }\n\n        .headerMenu {\n          border-top-left-radius: 16px;\n          border-top-right-radius: 16px;\n          overflow: hidden;\n          transform: translateX(100%);\n          flex-direction: column;\n          padding-left: 0;\n          transition: 350ms ease-in-out;\n          transition-property: all;\n        }\n      }\n    }\n\n    @media @laptopS {\n      grid-template-columns: min-content 1fr auto;\n    }\n\n    .mainMenuButton {\n      display: flex;\n      align-items: center;\n      padding-right: 16px;\n      visibility: hidden;\n\n      @media @laptopM {\n        visibility: visible;\n      }\n    }\n\n    .leftActions {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n    }\n\n    .rightActions {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      padding-right: 8px;\n      justify-content: flex-end;\n    }\n\n    .menuButton {\n      display: none;\n      align-items: center;\n      padding-left: 16px;\n\n      @media @laptopM {\n        display: flex;\n      }\n    }\n\n    .exportsButton {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      padding: 8px;\n      border-radius: 4px;\n      transition: background-color 0.3s;\n\n      &:hover {\n        background-color: rgba(61, 197, 86, 0.1);\n      }\n\n      &:active {\n        background-color: rgba(61, 197, 86, 0.2);\n      }\n    }\n\n    .headerMenu {\n      background-color: @header-color;\n\n      @media @laptopS {\n        padding-left: 16px;\n      }\n\n      :global(.ant-menu-item) {\n        padding-left: 12px;\n        padding-right: 12px;\n\n        &:hover {\n          background-color: darken(@header-color, 3%);\n        }\n      }\n\n      :global(.ant-menu-item-icon) {\n        width: 1.2em;\n        height: 1.2em;\n        color: @icon-menu-sup-color;\n        position: relative;\n        top: 3px;\n\n        svg {\n          width: 100%;\n          height: 100%;\n        }\n      }\n\n      :global(.ant-menu-item-selected) {\n        background-color: darken(@header-color, 3%);\n\n        &::after {\n          border-bottom: 3px solid @icon-menu-sup-color;\n          margin-left: -16px;\n          margin-right: -16px;\n        }\n      }\n\n      :global(.ant-menu-sub) {\n        background-color: @header-color;\n      }\n\n      :global(.ant-menu-title-content) {\n        a {\n          color: white;\n          font-size: 13px;\n        }\n      }\n    }\n  }\n}\n\n.layout {\n  background-color: @bg-color;\n  min-height: calc(100vh - @header-height);\n\n  .wrapper {\n    min-height: calc(100vh - @header-height);\n  }\n\n  @media @mobileXL {\n    min-height: 100vh;\n\n    .wrapper {\n      min-height: 100vh;\n    }\n  }\n\n  .contentWrapper {\n    min-height: calc(100vh - 125px);\n    background-color: @bg-color;\n\n    &.isDesktop {\n      padding-left: 280px;\n    }\n\n    .content {\n      background-color: @dashboard-page;\n      margin-top: 8px;\n      padding: 16px 32px;\n      border-radius: 4px;\n\n      @media @laptopM {\n        padding: 16px;\n      }\n    }\n  }\n\n  .footer {\n    background-color: @bg-color;\n    height: 60px;\n    padding: 0;\n    font-size: 12px;\n    letter-spacing: 1.2px;\n    word-spacing: 2px;\n    display: flex;\n    align-items: center;\n    justify-content: centeR;\n  }\n\n  .sider {\n    min-height: calc(100vh - 65px);\n    background-color: @bg-menu-lateral;\n    box-shadow: @v2-bg-card-shadow;\n    padding-top: 16px;\n    position: fixed;\n\n    @media @mobileXL {\n      min-height: 100vh;\n    }\n\n    &.isMobile {\n      z-index: 9998;\n      top: 64px;\n\n      @media @mobileXL {\n        top: 0;\n      }\n    }\n\n    .menu {\n      background-color: @bg-menu-lateral;\n      border-right: initial;\n\n      :global(.ant-menu-item-icon) {\n        width: 1.5em;\n        height: 1.5em;\n        color: @green-400;\n        position: relative;\n\n        svg {\n          width: 100%;\n          height: 100%;\n        }\n      }\n\n      :global(.ant-menu-submenu-title),\n      :global(.ant-menu-item) {\n        height: initial;\n        margin: 0;\n        padding: 0 0;\n        overflow: initial;\n        margin-top: 10px;\n\n        &:before {\n          content: '';\n          position: absolute;\n          top: 0;\n          bottom: 0;\n          left: 0;\n          width: 0;\n          opacity: 0;\n          box-shadow: @v2-bg-card-shadow;\n          background-color: rgb(45, 93, 103);\n          transition: 150ms ease-in-out;\n          transition-property: all;\n        }\n\n        &:hover {\n          &:before {\n            opacity: 1;\n            width: 102%;\n          }\n        }\n      }\n\n      :global(.ant-menu-item-selected) {\n        background-color: initial;\n\n        &:before {\n          opacity: 1;\n          width: 102%;\n        }\n\n        &:after {\n          right: 0.5px;\n          display: none;\n        }\n      }\n\n      :global(.ant-menu-sub) {\n        background-color: @bg-menu-lateral;\n      }\n\n      :global(.ant-menu-title-content) {\n        color: white;\n        position: relative;\n        font-size: 16px;\n        display: block;\n\n        a {\n          color: white;\n          font-size: 16px;\n          display: block;\n        }\n      }\n\n      :global(.ant-menu-submenu-arrow) {\n        color: white;\n      }\n    }\n  }\n}\n\n:global(.ant-menu-submenu-popup) {\n  display: none;\n}\n","@import '~antd/lib/style/themes/default.less';\n@import './breakpoints.less';\n\n// Font\n@font-family: 'Roboto', 'Oswald', BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n  'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n  'Noto Color Emoji';\n\n// Color palette\n// Cores Primárias\n@primary-100: #91cc92;\n@primary-200: #67bf65;\n@primary-300: #3cb638;\n@primary-400: #2d8d2c;\n@primary-500: #1B752B; // Cor original\n@primary-600: #165e25;\n@primary-700: #10461f;\n@primary-800: #0b2f19;\n@primary-900: #051912;\n\n// Cores Secundárias\n@secondary-100: #90a8d4;\n@secondary-200: #668bc1;\n@secondary-300: #3d6eaf;\n@secondary-400: #2f5c9f;\n@secondary-500: #2B4675; // Cor original\n@secondary-600: #23405e;\n@secondary-700: #1b3948;\n@secondary-800: #122a31;\n@secondary-900: #091c1b;\n\n// Cores Terciárias\n@tertiary-100: #d48f90;\n@tertiary-200: #c16667;\n@tertiary-300: #af3e3f;\n@tertiary-400: #9f2d2f;\n@tertiary-500: #752B1B; // Cor original\n@tertiary-600: #5e2424;\n@tertiary-700: #46201b;\n@tertiary-800: #2f180f;\n@tertiary-900: #1c0c05;\n\n// Cores de Erro\n@error-100: #d49090;\n@error-200: #c16767;\n@error-300: #af3f3f;\n@error-400: #9f2e2e;\n@error-500: #751B2B; // Cor original\n@error-600: #5e2424;\n@error-700: #461e1e;\n@error-800: #2f1515;\n@error-900: #1c0909;\n\n// Cores de Aviso\n@warning-100: #d4d490;\n@warning-200: #c1c167;\n@warning-300: #afaf3f;\n@warning-400: #9f9f2d;\n@warning-500: #75751B; // Cor original\n@warning-600: #5e5e15;\n@warning-700: #46461e;\n@warning-800: #2f2f15;\n@warning-900: #1c1c09;\n\n// Cores de Informação\n@info-100: #90d4d4;\n@info-200: #67c1c1;\n@info-300: #3fafaf;\n@info-400: #2d9f9f;\n@info-500: #1B7575; // Cor original\n@info-600: #155e5e;\n@info-700: #0f4646;\n@info-800: #092f2f;\n@info-900: #051c1c;\n\n// Cinza\n@gray-100: #d4d4d4;\n@gray-200: #c1c1c1;\n@gray-300: #afafaf;\n@gray-400: #9f9f9f;\n@gray-500: #757575; // Cor original\n@gray-600: #5e5e5e;\n@gray-700: #464646;\n@gray-800: #2f2f2f;\n@gray-900: #1c1c1c;\n\n\n// Colors\n@v2-color-primary: rgb(144, 213, 221);\n@v2-color-secondary: #72bc75;\n@green-300: rgb(137, 235, 155);\n@green-400: rgb(29, 147, 51);\n@green-500: rgb(27, 117, 43);\n@red-500: rgb(128,0,0);\n@red-400: #B00020;\n@red-300: #f77777;\n@yellow-500: rgb(204, 148, 74);\n\n@font-size-mobile: 13px;\n@font-size-base: 13px;\n\n@title-font-size: 32px;\n@title-color: @green-500;\n\n@separator: #f0f0f0;\n@oddColor: #efefef;\n\n@subtitle-font-size: 22px;\n@subtitle-color: rgb(0, 65, 75);\n\n@bg-menu-lateral: rgb(0, 65, 75);\n@icon-menu-sup-color: rgb(61, 197, 86);\n@label-color: rgb(8, 108, 124);\n\n@header-color: #005866;\n@table-header-color: #005866;\n\n// Shadows\n@v2-bg-card-shadow: 0px 0px 10px 0px rgba(0,0,0,0.25);\n@v2-bg-label-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);\n@v2-bg-overlay-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);\n@v2-bg-card-mobile-shadow: 0px 0px 5px 0px rgba(0,0,0,0.30);\n\n// Backgrounds\n@bg-color: #ffffff;\n\n// Text colors\n@text-color: #454545;\n@input-color: #333;\n\n// Dev colors\n@dev-background: #444;\n@dev-button-hover: #222;\n@v2-bg-card: rgba(255,255,255,0.1);\n\n\n\n// Sizes\n@header-height: 60px;\n@menu-width: 200px;\n\n// V2\n@v2-bg-color: #222629;\n\n\n@bg-card: #37393B;\n@dashboard-page: lighten(@bg-color, 20%);\n\n// Titles\n@v2-menu-title: #ddd;\n\n// Menu\n@v2-text-color: @text-color;\n@v2-text-color-hover: #ccc;\n\n// Animations\n@animation-time: 450ms;\n\n:global(.ant-notification) {\n  z-index: 20000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ant-notification": `ant-notification`,
	"antNotification": `ant-notification`,
	"copyright": `dashboard-module__copyright--eG692`,
	"layoutHeader": `dashboard-module__layoutHeader--h0fZ6`,
	"layoutOutlet": `dashboard-module__layoutOutlet--wlXoS`,
	"header": `dashboard-module__header--Ju_4i`,
	"mobileMenu": `dashboard-module__mobileMenu--kCdBa`,
	"opened": `dashboard-module__opened--o2dlS`,
	"headerMenu": `dashboard-module__headerMenu--nN4l8`,
	"mainMenuButton": `dashboard-module__mainMenuButton--Of9IF`,
	"leftActions": `dashboard-module__leftActions--nVFj7`,
	"rightActions": `dashboard-module__rightActions--bFFXz`,
	"menuButton": `dashboard-module__menuButton--UdHib`,
	"exportsButton": `dashboard-module__exportsButton--flROV`,
	"ant-menu-item": `ant-menu-item`,
	"antMenuItem": `ant-menu-item`,
	"ant-menu-item-icon": `ant-menu-item-icon`,
	"antMenuItemIcon": `ant-menu-item-icon`,
	"ant-menu-item-selected": `ant-menu-item-selected`,
	"antMenuItemSelected": `ant-menu-item-selected`,
	"ant-menu-sub": `ant-menu-sub`,
	"antMenuSub": `ant-menu-sub`,
	"ant-menu-title-content": `ant-menu-title-content`,
	"antMenuTitleContent": `ant-menu-title-content`,
	"layout": `dashboard-module__layout--exWag`,
	"wrapper": `dashboard-module__wrapper--UgHhS`,
	"contentWrapper": `dashboard-module__contentWrapper--X6J1u`,
	"isDesktop": `dashboard-module__isDesktop--I7nzq`,
	"content": `dashboard-module__content--tR01X`,
	"footer": `dashboard-module__footer--qxK1M`,
	"sider": `dashboard-module__sider--nQ3Gs`,
	"isMobile": `dashboard-module__isMobile--HzwXt`,
	"menu": `dashboard-module__menu--gEt2m`,
	"ant-menu-submenu-title": `ant-menu-submenu-title`,
	"antMenuSubmenuTitle": `ant-menu-submenu-title`,
	"ant-menu-submenu-arrow": `ant-menu-submenu-arrow`,
	"antMenuSubmenuArrow": `ant-menu-submenu-arrow`,
	"ant-menu-submenu-popup": `ant-menu-submenu-popup`,
	"antMenuSubmenuPopup": `ant-menu-submenu-popup`
};
export default ___CSS_LOADER_EXPORT___;
